// src/components/layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';



const Footer = () => {
  return (
    <footer className="footer-main">
      <div className="container">
        <div className="row g-4">
          {/* Brand Section */}
          <div className="col-lg-4 col-md-6">
            <h1 className="footer-brand">halal-bees</h1>
            <p>
              Discover authentic Halal dining experiences near you. Your trusted platform
              for finding and booking Halal-certified restaurants.
            </p>
            <div className="social-icons">
              <Link to="#" className="social-icon text-white" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </Link>
              <Link to="#" className="social-icon text-white" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </Link>
              <Link to="#" className="social-icon text-white" aria-label="Twitter">
                <i className="bi bi-twitter-x"></i>
              </Link>
              <Link to="#" className="social-icon text-white" aria-label="YouTube">
                <i className="bi bi-youtube"></i>
              </Link>
            </div>

            {/* App Download Section */}
            {/* <div className="mt-4">
              <h6 className="footer-section-title">Get Our App</h6>
              <Link to="#" className="app-download text-white text-decoration-none" aria-label="Download on the App Store">
                <i className="bi bi-apple fs-4"></i>
                <div>
                  <small>Download on the</small>
                  <div>App Store</div>
                </div>
              </Link>
              <Link to="#" className="app-download text-decoration-none text-white"  aria-label="Get it on Google Play">
                <i className="bi bi-google-play fs-4"></i>
                <div>
                  <small>Get it on</small>
                  <div>Google Play</div>
                </div>
              </Link>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="footer-section-title">Quick Links</h6>
            <div className="d-flex flex-column">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/restaurants" className="footer-link">Restaurants</Link>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/blog" className="footer-link">Blog</Link>
              <Link to="/hotels" className="footer-link">Hotels</Link>
              {/* <Link to="/careers" className="footer-link">Careers</Link> */}
              {/* <Link to="/faq" className="footer-link">FAQ</Link> */}
            </div>
          </div>

          {/* For Restaurants */}
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title">For Restaurants</h6>
            <div className="d-flex flex-column">
              <Link to="/partner" className="footer-link">Join as Partner</Link>
              <Link to="/restaurant-login" className="footer-link">Restaurant Login</Link>
              <Link to="/partner-support" className="footer-link">Partner Support</Link>
              <Link to="/success-stories" className="footer-link">Success Stories</Link>
            </div>

            {/* Halal Certification */}
            <div className="halal-certification">
              <i className="bi bi-patch-check-fill fs-4 text-success"></i>
              <div>
                <h6 className="mb-0">Halal Certified</h6>
                <small>All restaurants verified</small>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-section-title">Contact Us</h6>
            <div className="contact-info-item">
              <div className="contact-icon">
                <i className="bi bi-geo-alt"></i>
              </div>
              <div>
                London
              </div>
            </div>
            <div className="contact-info-item">
              <div className="contact-icon">
                <i className="bi bi-envelope"></i>
              </div>
              <div>
                info@halal-bees.com
              </div>
            </div>
            <div className="contact-info-item">
              {/* <div className="contact-icon">
                <i className="bi bi-telephone"></i>
              </div> */}
              <div>
                {/* (123) 456-7890 */}
              </div>
            </div>


            {/* Hours */}
            <div className="mt-4">
              <h6 className="footer-section-title">Business Hours</h6>
              <div className="mb-2">Monday - Friday: 9AM - 10PM</div>
              <div>Saturday - Sunday: 10AM - 11PM</div>
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="row">
          <div className="col-12">
            <div className="newsletter-box">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h5 className="mb-2">Subscribe to Our Newsletter</h5>
                  <p className="mb-md-0">Get updates about new restaurants and exclusive offers</p>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control newsletter-input"
                      placeholder="Enter your email"
                    />
                    <button className="btn btn-success">Subscribe</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-copyright">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <p className="copyright-text mb-md-0">
                  © {new Date().getFullYear()} <span>halal-bees</span>. All rights reserved.
                </p>
              </div>
              <div className="col-md-6">
                <div className="copyright-links text-md-end text-center">
                  <Link to="/privacy">Privacy Policy</Link>
                  <Link to="/terms">Terms of Service</Link>
                  <Link to="/sitemap">Sitemap</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;